import { getKeyFromIds, initialKeyState } from './reducer'

/**
 * @returns {(Object) => initialKeyState}
 */
export function biReportByAccountAndName(accountId, reportType) {
  const key = getKeyFromIds(accountId, reportType)
  return state => state.biReports[key] ?? initialKeyState
}
